const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/add-counting-list-line.action';
            binding.dataActions[actionPath] = require('partner/actions/add-counting-list-line.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-counting-list.action';
            binding.dataActions[actionPath] = require('partner/actions/create-counting-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-auto-suggest-suggestions-filtered.action';
            binding.dataActions[actionPath] = require('partner/actions/get-auto-suggest-suggestions-filtered.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-brand-scheme.action';
            binding.dataActions[actionPath] = require('partner/actions/get-brand-scheme.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-brand-schemes.action';
            binding.dataActions[actionPath] = require('partner/actions/get-brand-schemes.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-by-ids-dlvry.action';
            binding.dataActions[actionPath] = require('partner/actions/get-by-ids-dlvry.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-cached-active-prices.action';
            binding.dataActions[actionPath] = require('partner/actions/get-cached-active-prices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-counting-list-products.action';
            binding.dataActions[actionPath] = require('partner/actions/get-counting-list-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-counting-list.action';
            binding.dataActions[actionPath] = require('partner/actions/get-counting-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-counting-lists.action';
            binding.dataActions[actionPath] = require('partner/actions/get-counting-lists.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-extended-customer.action';
            binding.dataActions[actionPath] = require('partner/actions/get-extended-customer.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-inventory-configuration.action';
            binding.dataActions[actionPath] = require('partner/actions/get-inventory-configuration.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-organization-address.action';
            binding.dataActions[actionPath] = require('partner/actions/get-organization-address.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-pickup-dlv-mode.action';
            binding.dataActions[actionPath] = require('partner/actions/get-pickup-dlv-mode.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-lists-by-product-id.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-lists-by-product-id.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-unit-of-measure-options.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-unit-of-measure-options.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-replacements-by-product-id.action';
            binding.dataActions[actionPath] = require('partner/actions/get-replacements-by-product-id.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-ship-carrier-address.action';
            binding.dataActions[actionPath] = require('partner/actions/get-ship-carrier-address.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-unit-of-measure-conversions-by-id.action';
            binding.dataActions[actionPath] = require('partner/actions/get-unit-of-measure-conversions-by-id.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-upcoming-order-entry-deadline.action';
            binding.dataActions[actionPath] = require('partner/actions/get-upcoming-order-entry-deadline.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/update-calc-cart-lines.action';
            binding.dataActions[actionPath] = require('partner/actions/update-calc-cart-lines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/update-counting-list-lines.action';
            binding.dataActions[actionPath] = require('partner/actions/update-counting-list-lines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/update-counting-list.action';
            binding.dataActions[actionPath] = require('partner/actions/update-counting-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/validate-alcohol-license.action';
            binding.dataActions[actionPath] = require('partner/actions/validate-alcohol-license.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };